
/* prettier-ignore */

import { Injectable, computed, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { EMPTY, Observable, Subscription, catchError, tap, throwError } from 'rxjs';
import { ChatStylesRequest } from '../interface/chatStyles.interface';
import { DataChatService } from './dataChat.service';
import { CssStylesService } from './cssStyles.service';
import { ScrollService } from './scrollContainer.service';
import { DebugService } from 'src/app/services/debug.service';
import { TranslationService } from 'src/app/services/translation.service';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root',
})

export class RequestService {
  private readonly baseUrl: string = `${environment.apiAssistantUrlBase}/api`; //environments.baseUrl;
  // CMAD-189: los estilos/textos del chat se piden directo al CMS (el asistente solo los proxyaba
  // hacia CMS_API_BASE_URL, que en algunos entornos apunta a otro CMS).
  private readonly baseUrlCms: string = `${environment.apiUrlBase}/api`;
  private readonly urlChatHistory = computed(() => `${environment.urlChatHistory}?user_id=${this.dataChat.token()}&service=${this.dataChat.id()}`);

  public headers = new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: 'Bearer 3db0e94b-d4ec-4e86-8350-894a1432f663',
  });

  private debugService = inject(DebugService);
  public cssStyles = inject(CssStylesService);
  public http = inject(HttpClient);
  public dataChat = inject(DataChatService);
  private _translationService = inject(TranslationService);
  public scrollService = inject(ScrollService);
  public durationChatSubscription?: Subscription

  public saveChat(email: string, name: string | null): Observable<any> {
    const data = JSON.stringify({
      token: this.dataChat.token(),
      chat_id: this.dataChat.id(),
      email,
      name,
      lang: this._translationService.displayLanguage(),
      new: 1,
    });

    return this.http.post(`${this.baseUrl}/send-email-conversation`, data, { headers: this.headers })
      .pipe(
        catchError((error: unknown) => {
          this.debugService.error(error, '[RequestService] Error in saveChat');
          return throwError(() => new Error('Error in saveChat'));
        })
      );
  }

  public sendConversation(messages: any): Observable<any> {
    let data: any = {
      token: this.dataChat.token(),
      chat_id: this.dataChat.id(),
    };

    data = {
      ...data,
      messages,
    };

    return this.http.post(`${this.baseUrl}/save-chatbase-conversation`, data, {
      headers: this.headers,
    });
  }

  public getMessages(): Observable<ChatStylesRequest> {
    return this.http
      .get(
        `${this.baseUrl}/get-cicerone-data-chat/${this.dataChat.id() || '18'
        }/${this._translationService.displayLanguage()}`
      )
      .pipe(
        catchError((error: any) => {
          return throwError(
            () =>
              new Error(
                `No se han podido sincronizar los datos: ${error.error.message}`
              )
          ) as Observable<ChatStylesRequest>;
        }),
        tap((data: any) => {
          //console.log({data})
        })
      );
  }


  public getChatDataStyles(): Observable<any> {
    return this.http.get(`${this.baseUrlCms}/get-cicerone-data-chat/${this.dataChat.id()}/${this._translationService.displayLanguage()}`)
      .pipe(
        catchError((error: any) => {
          return throwError(() => new Error(`No se han podido sincronizar los datos: ${error.error.message}`)) as Observable<ChatStylesRequest>;
        })
      );
  }

  public getHistory() {
    return this.http.get<any>(this.urlChatHistory()).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 400 && err.error?.status === 'error_processing')
          return EMPTY;

        return throwError(() => new Error('HTTP getHistory failed', { cause: err }));
      }),
    );
  }

  public sendImage(data: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/chat/image`, data, {
      reportProgress: true,
      observe: 'events'
    });
  }

}
